import api from '@/api'
import { OptionSelector } from '@/components'
import DatePicker from '@/components/Form/DatePicker'
import { useForm } from '@/hooks'
import { t } from '@/i18n'
import CustomerSelector from '@/pages/Customer/customerSelector'
import DriverSelector from '@/pages/Drivers/driverSelector'
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import * as yup from 'yup'
import {
  CarCarPositionLocationChoices,
  CarPositionNode,
} from '../../../apollo/graphql/generated/types'
import { BaseModal } from '../base-modal/base-modal'
import styles from './CarPositionModal.module.scss'

interface CarPositionModalProps {
  isOpen: boolean
  onClose: () => void
  onSubmit: (position: Partial<CarPositionNode>) => void
  initialData?: Partial<CarPositionNode>
  onSuccess?: () => void
  carId: string
}


export const CarPositionModal: React.FC<CarPositionModalProps> = ({
  isOpen,
  onClose,
  onSubmit,
  initialData,
  onSuccess,
  carId,
}) => {
  const navigate = useNavigate()
  const [isLoading, setIsLoading] = useState(false)

  const { control, isValid, onFormSubmit } = useForm<Partial<CarPositionNode>>({
    defaultValues: initialData,
    schema: yup.object({}),
    onSubmit: async data => {
      try {
        setIsLoading(true)
        await api.post('cars/car-position/', {
          ...data,
          car: carId,
        })
        onSubmit(data)
        onSuccess?.()
        toast.success(t('car_position_created'))
        onClose()
      } catch (error) {
        console.error('Failed to create car position:', error)
        toast.error(t('car_position_creation_failed'))
      } finally {
        setIsLoading(false)
      }
    },
  })

  const locationOptions = Object.values(CarCarPositionLocationChoices).map(
    location => ({
      value: location,
      label: location,
    }),
  )

  return (
    <BaseModal
      isOpen={isOpen}
      onClose={onClose}
      modalTitle="Create Car Position"
      actions={[
        <button
          key="submit"
          type="submit"
          form="car-position-form"
          className={styles.submitButton}
          disabled={!isValid || isLoading}
        >
          {isLoading ? t('loading') : t('confirm')}
        </button>,
      ]}
    >
      <form
        id="car-position-form"
        onSubmit={onFormSubmit}
        className={`${styles.form} form-fields`}
      >
        <OptionSelector
          name="location"
          control={control}
          options={locationOptions}
          label="מקום"
          className="w-50"
          menuPlacement="top"
        />
        <DriverSelector
          creatable
          onCreateOption={() => navigate(`/cars/${carId}/drivers/add`)}
          isFormElement
          className="w-50"
          isEditing={true}
          filterCustomer={false}
          control={control}
          name="driver"
        />
        <CustomerSelector
          isFormElement
          className="w-50"
          control={control}
          isEditing={true}
          name="customer"
        />
        <DatePicker
          name="startTime"
          control={control}
          label="תאריך מסירה"
          isEditing={true}
        />
        <DatePicker
          name="endTime"
          control={control}
          label="תאריך איסוף"
          isEditing={true}
        />
      </form>
    </BaseModal>
  )
}
